import { FreelanceCompaniesPage } from 'features/freelance-companies/FreelanceCompaniesPage';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { config } from 'utils/config';

export default FreelanceCompaniesPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'freelance-companies'
      ])),
      baseUrl: config.appUrl,
      bannerText: '', // Placeholder
      testimonials: [] // Placeholder
    },
    revalidate: 30
  };
};
